// src/utils/ipix.js

/**
 * Utility untuk membangun URL IPX dengan modifiers
 */

// Base URL IPX service yang digunakan
export const DEFAULT_BASE = 'https://ipx-server.sarbeh.com/_ipx'

// Map dari nama opsi friendly ke kode short IPX
export const KEY_MAP = {
    width: 'w',
    height: 'h',
    quality: 'q',
    format: 'f',
}

/**
 * Bangun URL IPX:
 *   /_ipx/{modifiers}/{encodeURIComponent(src)}
 *
 * @param {string} src  URL asli gambar (raw)
 * @param {Object} opts Opsi IPX { width, height, quality, format }
 * @param {string} base Base URL IPX (DEFAULT_BASE)
 * @returns {string} URL lengkap dengan modifiers
 */
export function ipxUrl(src, opts = {}, base = DEFAULT_BASE) {
    const parts = Object.entries(opts)
        .filter(([, v]) => v != null && v !== '')
        .map(([k, v]) => `${KEY_MAP[k]}_${v}`)

    const modifier = parts.join(',')
    const encoded = encodeURIComponent(src)
    return `${base}/${modifier}/${encoded}`
}

/**
 * Generate atribut srcSet untuk responsive images via IPX
 *
 * @param {string} src          URL asli gambar
 * @param {number[]} widths     Array daftar width (px), misal [240,320,480]
 * @param {Object} [options]    Opsi tambahan: { quality, format }
 * @param {number} [options.quality]
 * @param {string} [options.format]
 * @param {string} [base]
 * @returns {string} srcSet string, contoh: "... 240w, ... 320w, ... 480w"
 */
export function generateSrcSet(
    src,
    widths,
    { quality, format } = {},
    base = DEFAULT_BASE
) {
    return widths
        .map((w) => {
            const opts = { width: w, height: w }
            if (quality != null) opts.quality = quality
            if (format != null) opts.format = format

            const url = ipxUrl(src, opts, base)
            return `${url} ${w}w`
        })
        .join(', ')
}

/**
 * Default sizes attribute sesuai breakpoints Tailwind:
 *   - md (>=768px): 480px
 *   - sm (>=640px): 320px
 *   - base (<640px): 240px
 */
export const defaultSizes =
    '(min-width: 768px) 480px, (min-width: 640px) 320px, 240px'
